<template>
  <div>
    <div v-for="a in itens" class="card p-3 mb-3">
      <div class="mb-1">
        <span v-if="a.tipo === '1'" class="badge badge-success mr-1">Novidades</span>
        <span v-if="a.tipo === '2'" class="badge badge-warning mr-1">Avisos</span>
        <span v-if="a.tipo === '3'" class="badge badge-danger mr-1">Ocorrências</span>
        {{a.data_informe}}
      </div>
      <h5 class="font-weight-bolder mb-0">{{ a.titulo }}</h5>
      <p v-if="a.subtitulo" class="mb-1">{{ a.subtitulo }}</p>
      <div v-if="a.img_informe" class="mt-2 mb-3">
        <img :src="a.img_informe" class="img-bkg">
      </div>
      <div v-html="a.texto_informe"></div>
      <div v-if="a.alerta" class="alert alert-warning small my-1" v-html="a.alerta">{{ a.alerta }}</div>
    </div>
    <div v-show="!itens.length" class="text-center mt-5">
      <i aria-hidden="true" class="fas fa-check-circle fa-2x text-muted d-block mb-3"></i>
      Tudo certo por aqui!
    </div>
  </div>
</template>

<script>
export default {
  props: ['itens'],
  name: "NotificacaoLista"
}
</script>

<style scoped>
.img-bkg {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
